// <head> metadata for SolutionsCronHostingPage (https://www.dbos.dev/solutions/cron-hosting).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Cron Job Hosting',
    },
    {
      name: 'description',
      content:
        'Create failure-proof cron jobs in minutes. Deploy them to DBOS Cloud.with 1 click and run them for free. Secure. Observable. Reliable.',
    },
    {
      property: 'og:title',
      content: 'Cron Job Hosting',
    },
    {
      property: 'og:description',
      content:
        'Create failure-proof cron jobs in minutes. Deploy them to DBOS Cloud.with 1 click and run them for free. Secure. Observable. Reliable.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675bb12f6bb3a40e7a2c9706_Free-Cron-Job-Hosting-Platform-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Cron Job Hosting',
    },
    {
      name: 'twitter:description',
      content:
        'Create failure-proof cron jobs in minutes. Deploy them to DBOS Cloud.with 1 click and run them for free. Secure. Observable. Reliable.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675bb12f6bb3a40e7a2c9706_Free-Cron-Job-Hosting-Platform-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/solutions/cron-hosting',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
